import { getConfigItem } from "../config";
import { VALID_INCOMING_EVENTS } from "./incoming";
import { MessageSender } from "./types";
export function sendMessageToTestBox(event, data) {
    const targetWindow = getConfigItem("window", window.parent);
    targetWindow.postMessage(makeTestBoxEvent(event, data), "*");
}
export function makeTestBoxEvent(event, data) {
    return {
        testbox: {
            version: 1,
            sender: MessageSender.PARTNER,
            event,
            data,
        },
    };
}
export function isValidIncomingTestBoxMessage(obj, dataGuard) {
    if (typeof obj === "object" &&
        obj !== null &&
        "testbox" in obj &&
        typeof obj["testbox"] === "object") {
        const { testbox: message } = obj;
        // Make sure this is a valid version and event
        if (message.version === 1 &&
            VALID_INCOMING_EVENTS.includes(message.event) &&
            message.sender === MessageSender.APP) {
            if (dataGuard) {
                return dataGuard(message.data);
            }
            return true;
        }
    }
    return false;
}
